// 验证类
import Verify from '../../utils/verify.js';
// 枚举类：发货方式
import DeliveryTypeEnum from '../../utils/enum/DeliveryType.js';
// 枚举类：支付方式
import PayTypeEnum from '../../utils/enum/order/PayType';

const now = new Date();
export default {
    name: 'checkout',
    components: {
        Verify,
        DeliveryTypeEnum,
        PayTypeEnum
    },
    data() {
        return {
            promo_price: 0, // 优惠码价格
            promo_code: '', // 优惠码
            isPromoCodeDisabled: false,
            isEnterPromoCode: false,
            isAllGoods: false, //全部商品展示
            tips: '如需使用 PayPal 支付，请联系客服。',
            // 默认收货地址
            address: {},
            // 当前页面参数
            options: {},
            isShowPay: false, // 是否显示现金支付弹出
            setting: {
                delivery: [], // 支持的配送方式
            },
            // 配送方式
            isShowTab: false,
            DeliveryTypeEnum,
            curDelivery: null,
            deliveryTime: '当日送达',
            proper_exist_in: 0, // 是否支持现金支付
            // 支付方式
            PayTypeEnum,
            curPayType: 0,
            exist_address: false, // 是否存在收货地址
            selectedShopId: 0, // 选择的自提门店id
            linkman: '', // 自提联系人
            phone: '', // 自提联系电话
            // 商品信息
            goods: {},
            // 选择的优惠券
            selectCouponId: 0,
            // 是否使用积分抵扣
            isUsePoints: false,
            // 是否使用优惠码
            isPromoCode: false,
            // 买家留言
            remark: '',
            // 禁用submit按钮
            disabled: false,
            has_error: false,
            error_msg: '',
            notRefresh: false, // 不允许刷新
            coupon_id: 0, //优惠券 id
            coupon_list: {}, // 优惠券列表
            coupon_money: 0, // 优惠金额
            exchange: '', // 汇率
            delivery: 10, // 发货方式
            express_price: 0, // 运费金额
            extract_shop: [],
            goods_list: [], // 商品列表
            intra_region: false,
            is_allow_points: false, // 是否开启积分抵扣
            is_use_points: "0", //可用积分
            last_extract: {}, // 自提联系信息
            order_pay_price: 0, // 订单支付金额
            order_price: 0, // 商品金额
            order_total_num: 0, // 订单商品总数
            order_total_price: 0, // 订单金额
            order_pay_price_rmb: 0,
            pay_type: 30, // 支付类型 10 余额 20 微信支付 30 信用卡支付 40 信用卡支付
            points_bonus: 0, // 奖励积分
            code_id: 0, //优惠码ID
            points_money: 0, // 积分抵扣金额
            showBottomPopup: false, // 是否弹出优惠券弹窗
            timelist: [],
            time: '任意时间段', // 选择的配送时间段
        }
    },
    //视图加载前执行
    created() {
        let _this = this;
        this.loading = this.$toast.loading('Loading...', {
            coverColor: "rgba(0,0,0,0.5)",
        });
        _this.options = _this.$route.query;
        _this.curDelivery = _this.$ls.get('curDelivery') ? _this.$ls.get('curDelivery') : 10; // 配送方式记忆
        _this.selectedShopId = _this.$ls.get('shippingLocation_id') ? _this.$ls.get('shippingLocation_id') : 0;
        // 获取当前订单信息
        !_this.notRefresh && _this.getOrderData();
        _this.getTimeList(); // 获取时间列表
    },
    //视图加载完成执行
    mounted() {
        let _this = this;
        // 获取温馨提示字段内容
        _this.getTips();
    },
    methods: {

        // 获取提示信息
        getTips() {
            let _this = this;
            _this._get('wxapp/tips', {}, res => {
                _this.setData({
                    tips: res.msg
                })
            })
        },

        // 改变优惠码状态
        onPromoCode(e) {
            let _this = this;
            _this.isEnterPromoCode = e;
            if (!_this.promo_code) {
                return false;
            }
            _this.isPromoCode = e;
            // 重新获取订单信息
            _this.getOrderData();
        },


        /**
         * 获取当前订单信息
         */
        getOrderData() {
            let _this = this,
                options = _this.options;
            // 获取订单信息回调方法
            let callback = result => {
                let resData = result.data;
                // 请求错误
                if (result.code !== 1) {
                    _this.$toast.fail(result.msg);
                    return false;
                }
                // 显示错误信息
                if (resData.has_error) {
                    _this.$toast.fail(resData.error_msg);
                }

                let data = {};
                // 当前选择的配送方式
                data.curDelivery = resData.delivery;
                // 如果只有一种配送方式则不显示选项卡
                data.isShowTab = resData.setting.delivery.length > 1;
                // 上门自提联系信息
                if (_this.linkman === '') {
                    data.linkman = resData.last_extract.linkman;
                }
                if (_this.phone === '') {
                    data.phone = resData.last_extract.phone;
                }
                // 设置页面数据
                _this.setData(Object.assign({}, resData, data));
            };

            this.loading = this.$toast.loading('加载中', {
                coverColor: "rgba(0,0,0,0.5)",
            });

            // 请求的参数
            let params = {
                delivery: _this.curDelivery || 0,
                shop_id: _this.selectedShopId || 0,
                coupon_id: _this.selectCouponId || 0,
                is_use_points: _this.isUsePoints ? 1 : 0,
                paystate: _this.curPayType == 40 ? 'backpay' : 20,
                client: 'h5',
                promo_code: _this.promo_code,
                is_promo_code: _this.isPromoCode ? 1 : 0,
            };

            // 立即购买
            if (options.order_type === 'buyNow') {
                _this._get('order/buyNow', Object.assign({}, params, {
                    goods_id: options.goods_id,
                    goods_num: options.goods_num,
                    goods_sku_id: options.goods_sku_id,
                }), result => {
                    _this.loading.hide();
                    callback(result);
                });
            }

            // 购物车结算
            else if (options.order_type === 'cart') {
                _this._get('order/cart', Object.assign({}, params, {
                    cart_ids: options.cart_ids || 0,
                }), result => {
                    _this.loading.hide();
                    callback(result);
                });
            }
        },

        /**
         * 快递配送：选择收货地址
         */
        onSelectAddress() {
            let _this = this;
            // 允许刷新
            _this.setData({
                notRefresh: false
            });
            _this.navigationTo('/member/address');
        },

        // 获取时间列表
        getTimeList() {
            let _this = this;
            _this._get('order/timeList', {}, res => {
                res.data.list.forEach(function (item, index) {
                    _this.setData({
                        timelist: _this.timelist.concat(item.content)
                    })
                })
            });
        },

        // 选择配送时间时间
        selectTime() {
            this.isShowPay = false
        },


        /**
         * 选择优惠券
         */
        onSelectCoupon(user_coupon_id) {
            let _this = this;
            // 记录选中的优惠券id
            _this.setData({
                selectCouponId: user_coupon_id
            });
            // 重新获取订单信息
            _this.getOrderData();
            // 隐藏优惠券弹层
            _this.onTogglePopupCoupon();
        },

        // 选择支付方式
        onSelectPayType(e) {
            let _this = this;
            // 设置当前支付方式
            _this.setData({
                curPayType: e,
                isShowPay: e == _this.PayTypeEnum.CASH.value ? true : false,
            });
            _this.getOrderData();
        },


        /**
         * 选择优惠券(弹出/隐藏)
         */
        onTogglePopupCoupon() {
            let _this = this;
            if (_this.coupon_list.length > 0) {
                _this.setData({
                    showBottomPopup: !_this.showBottomPopup
                });
            }
        },

        /**
         * 不使用优惠券
         */
        onNotUseCoupon() {
            let _this = this;
            _this.setData({
                selectCouponId: 0
            });
            // 重新获取订单信息
            _this.getOrderData();
            // 隐藏优惠券弹层
            _this.onTogglePopupCoupon();
        },


        /**
         * 积分选用
         */
        onTriggerPoints: function (e) {
            let _this = this;
            _this.isUsePoints = e;
            // 重新获取订单信息
            _this.getOrderData();
        },


        /**
         * 订单提交
         */
        onSubmitOrder() {
            let _this = this,
                options = _this.options;
            if (_this.disabled) {
                return false;
            }

            // 表单验证
            if (!_this._onVerify()) {
                return false;
            }

            // 按钮禁用, 防止二次提交
            _this.disabled = true;

            let url = '';

            // 表单提交的数据
            let postData = {
                delivery: _this.curDelivery,
                pay_type: _this.curPayType,
                shop_id: _this.selectedShopId || 0,
                linkman: _this.linkman,
                phone: _this.phone,
                coupon_id: _this.selectCouponId || 0,
                is_use_points: _this.isUsePoints ? 1 : 0,
                remark: _this.remark || '',
                client: 'h5',
                time: _this.time, // 要求配送时间
                code_id: _this.code_id, // 优惠码ID
                promo_code: _this.promo_code, //优惠码
                code_money: _this.promo_price, // 优惠码金额
                is_promo_code: _this.isPromoCode ? 1 : 0, // 是否使用优惠码
                paystate: _this.curPayType == 40 ? 'backpay' : 20,
            };

            // 创建订单-立即购买
            if (options.order_type === 'buyNow') {
                url = 'order/buyNow';
                postData = Object.assign(postData, {
                    goods_id: options.goods_id,
                    goods_num: options.goods_num,
                    goods_sku_id: options.goods_sku_id,
                });
            }

            // 创建订单-购物车结算
            if (options.order_type === 'cart') {
                url = 'order/cart';
                postData = Object.assign(postData, {
                    cart_ids: options.cart_ids || 0,
                });
            }

            _this.$dialog({
                title: "订单确认",
                content: "即将前往结算台,请最后确认您选购的商品和支付方式是否正确!",
                okBtnTxt: "去结算",
                // 点击结算
                onOkBtn(event) {
                    this.loading = this.$toast.loading('交易处理中...', {
                        coverColor: "rgba(0,0,0,0.5)",
                    });
                    postData.sss = 'h5';  // 提交来源区分
                    // 订单提交
                    _this._post_form(url, postData, result => {
                        _this._onSubmitCallback(result);
                        // 解除按钮禁用
                        _this.loading.hide();
                        _this.disabled = false;
                    },()=>{
                        _this.loading.hide();
                    });
                    // 不允许刷新
                    _this.setData({
                        notRefresh: true
                    });
                    this.close(); //关闭对话框
                },
                // 点击取消
                onCancelBtn(event) {
                    // 解除按钮禁用
                    _this.disabled = false;
                    // 不允许刷新
                    _this.setData({
                        notRefresh: true
                    });
                },
            });

        },

        // 创建订单成功回调
        _onSubmitCallback(result) {
            let _this = this;
            if (result.code === -10) {
                _this.$toast.fail(result.msg, {
                    onClose: _this.redirectToOrderIndex()
                });
                _this.redirectToOrderIndex();
                return false;
            }
            // 发起微信支付
            if (result.data.pay_type_h5 == PayTypeEnum.WECHAT.value) {
                window.location.href = result.data.payment.mweb_url;
            }
            // 余额支付
            if (result.data.pay_type_h5 == PayTypeEnum.BALANCE.value) {
                _this.$toast.success(result.msg.success, {
                    onClose: _this.redirectToOrderIndex()
                });
            }
            // 现金支付
            if (result.data.pay_type_h5 == PayTypeEnum.CASH.value) {
                _this.$toast.success(result.msg.success, {
                    onClose: _this.redirectToOrderIndex()
                });
            }
            // 信用卡支付
            if (result.data.pay_type_h5 == PayTypeEnum.CARD.value) {
                if (result.url) {
                    window.location.href = result.url;
                } else {
                    _this.$toast.fail('订单支付失败', {
                        onClose: _this.redirectToOrderIndex()
                    });
                }
            }
        },

        /**
         * 跳转到未付款订单
         */
        redirectToOrderIndex() {
            let _this = this;
            _this.navigationTo('/member/order');
        },


        /**
         * 表单验证
         */
        _onVerify() {
            let _this = this;
            if (_this.has_error) {
                _this.$toast.fail(_this.error_msg);
                return false;
            }
            if (_this.curPayType == 0) {
                _this.$toast.fail('请选择支付方式');
                return false;
            }
            // if (_this.curPayType == 20) {
            //     _this.$toast.fail('微信支付通道暂时关闭');
            //     return false;
            // }
            return true;
        },


        /**
         *  开启全部商品
         */
        openAllGoods: function () {
            this.isAllGoods = true
        },
        /**
         *  关闭全部商品
         */
        closeAllGoods: function () {
            this.showBottomPopup = false
        },

        /**
         * 显示积分说明
         */
        onShowPoints() {
            let _this = this;
            _this.$dialog({
                lockBgScroll: true,
                noOkBtn: true,
                title: '积分规则说明',
                cancelBtnTxt: '我知道了',
                textAlign: 'left',
                content: _this.setting.points_describe.replace(/\n/g, '<br/>')
            });
        },


        // 格式化手机号码
        toFix: function (value) {
            return value.toFixed(2) // 此处2为保留两位小数，保留几位小数，这里写几
        },
    },
    destroyed() {
        let _this = this;
        //切记页面销毁需要销毁
        _this.loading.hide();
    }
}
